import { render } from "./UploadAudiosModal.vue?vue&type=template&id=56e34980&scoped=true&ts=true"
import script from "./UploadAudiosModal.vue?vue&type=script&lang=ts"
export * from "./UploadAudiosModal.vue?vue&type=script&lang=ts"

import "./UploadAudiosModal.vue?vue&type=style&index=0&id=56e34980&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56e34980"]])

export default __exports__